/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { createItem } from '@modules/utils/navigation'
import { FormattedMessage } from '@modules/i18n'
import Feature from '@modules/utils/feature'

import { isFeatureActivated } from '@/store' // eslint-disable-line import/no-restricted-paths

import { networkSecurityUrl } from './urls'

export function buildNetworkSecurityMenu(depth: number) {
  if (!isFeatureActivated(Feature.networkSecurity)) {
    return []
  }

  return [
    createItem({
      'data-test-id': `network-security-link`,
      name: <FormattedMessage id='navigation.networkSecurity' defaultMessage='Network security' />,
      href: networkSecurityUrl(),
      depth,
      items: [],
    }),
  ]
}
